import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { DialogService } from '../../dialog/dialog.service';
import { FeatureGuard } from '../../features-data/guards/feature.guard';
import { BannerCanvasTypesEnum } from '../../features-data/features-data.data';
import { FeaturesDataStore } from '../../features-data/features-data.store';
import { Toggles } from '../../features-data/sub-models/toggles.model';
import { SETTINGS_MASTER_ROUTE } from '../../main/main.data';
import { NavigationService } from '../../navigation/navigation.service';

@Injectable()
export class TeamMembersPermissionGuard
  extends FeatureGuard
  implements CanActivate {
  constructor(
    featuresDataStore: FeaturesDataStore,
    navigationService: NavigationService,
    dialogService: DialogService
  ) {
    super(featuresDataStore, navigationService, dialogService);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return super.checkFeatureAccess(
      Toggles.KEYS.ADD_USERS,
      SETTINGS_MASTER_ROUTE,
      BannerCanvasTypesEnum.feature_lock
    );
  }
}
